import React from "react";
import { motion } from "framer-motion";
import { APPROACH } from "@/constants/testIds";

const CHAPTERS = [
  {
    n: "01",
    title: "The unspoken, first.",
    body:
      "Psychodynamic work begins where words often stop — with the feelings that leak out sideways, the patterns that repeat, the parts of ourselves we&rsquo;ve learned to hide. We start there, gently.",
  },
  {
    n: "02",
    title: "Time, on your side.",
    body:
      "We move at your pace. Sessions are one steady hour, usually at the same day and time each week. That rhythm — kept for you — is itself part of the work.",
  },
  {
    n: "03",
    title: "Nothing needs performing.",
    body:
      "There is nothing you need to bring, prepare, or pretend. Silence is welcome. So is confusion. What matters is that whatever arrives is met, without judgement.",
  },
  {
    n: "04",
    title: "Insight, not advice.",
    body:
      "Together we listen for what your mind is trying to say. The aim isn&rsquo;t to be told what to do, but to know yourself with more honesty.",
  },
];

export default function Approach() {
  return (
    <section
      id="approach"
      data-testid={APPROACH.section}
      className="relative py-28 md:py-40 bg-muted/40"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-3xl"
        >
          <span className="text-xs uppercase tracking-[0.3em] text-muted-foreground">
            (02) &nbsp; The Approach
          </span>
        </motion.div>

        <div className="mt-16 md:mt-24 space-y-16 md:space-y-24">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{
                duration: 1,
                delay: i * 0.05,
                ease: [0.16, 1, 0.3, 1],
              }}
              className={`grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 items-start ${
                i % 2 === 1 ? "md:pl-24" : ""
              }`}
            >
              <div className="md:col-span-3">
                <div className="font-serif text-6xl md:text-8xl text-primary/80 leading-none">
                  {c.n}
                </div>
              </div>
              <div className="md:col-span-8">
                <h3 className="font-serif text-3xl md:text-4xl text-foreground leading-tight">
                  {c.title}
                </h3>
                <p
                  className="mt-5 text-base md:text-lg text-foreground/75 leading-relaxed max-w-2xl"
                  dangerouslySetInnerHTML={{ __html: c.body }}
                />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
